(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('RelationshipBankFeeAndChargesViewService', RelationshipBankFeeAndChargesViewService);

	RelationshipBankFeeAndChargesViewService.$inject = ['$resource'];

	function RelationshipBankFeeAndChargesViewService($resource) {
		var resourceUrl =  '/api';

		return $resource(resourceUrl, {}, {
			'getRelationshipBankViewDto':{
				method: 'GET',
				isArray: true,
				params: {customerId : '@customerId'},
				url: '/api/relationship-bank-fees-charges-view/:customerId/customerId',
		//		relationship-bank-fees-charges-view/{customerId}/customerId
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}

			}
		
		

		});
	}
})();
